<div [class.small]="small" [class.hover]="isHovering" [class.inProgress]="isUploading">
	@if (isUploading) {
		<nz-spin nzSimple nzSize="large" class="fade-in"></nz-spin>
	}
	<!--
  Disabled for now as the progress data isn't working quite right it seems to only
  show 0 or 100%. The previous upload system did a better job at the progress
  side of things so we'll just use a spinner for now until we decide to dig in &
  fix the progress data.

  nz-progress
  class="fade-in"
  *ngIf="isUploading"
  nzType="circle"
  [nzPercent]="percent"
  [nzStrokeColor]="{ '0%': '#108ee9', '50%': '#2db7f5', '100%': '#87d068' }"
  [nzWidth]="40"
></nz-progress-->

	@if (!isUploading) {
		<div class="upload-dropzone fade-in">
			<span class="ant-upload-drag-icon">
				<i nz-icon nzType="file-add"></i>
			</span>
			@if (!small) {
				<span class="ant-upload-text">{{ title }}</span>
			}
			<span class="ant-upload-hint"></span>
		</div>
	}

	<input
		#uploadInput
		type="file"
		name="uploads"
		[id]="uploadId"
		[multiple]="multiple"
		[accept]="accept"
		[disabled]="isUploading"
		(dragenter)="onDrag($event)"
		(dragleave)="onDrag($event)"
		(drop)="onDrop($event)"
		(click)="onClick($event)"
		(change)="onChange($event)"
	/>
</div>
